module.exports = __webpack_public_path__ + "img/calendar-fill.ff63c7f7.svg";